export class BanksFilter {
    id: number;
    name: string;
    CommitAmount: number;
    isSurety: boolean;
    isActive: boolean;
    availableCommitment: number;
}
